import { css } from '@emotion/react'
import React from 'react'

function ItemList({
    direction = 'horizentel',
    gap,
    wrap,
    title,
    children,
    style,
    bodyStyle
}) {
    const listStyle = css`
        display: flex;
        ${direction === 'horizental' && 'flex-direction: row'};
        ${direction === 'vertical' && 'flex-direction: column'};
        gap: ${gap};
        ${wrap && 'flex-wrap: wrap'};
        ${style};
    `
    return (
        <div css={bodyStyle}>
            {title}
            <div className="item-list" css={listStyle}>
                {children}
            </div>
        </div>
    )
}

export default ItemList
